import Navbar from "./Components/Navbar/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Shop from "./Pages/Shop";
import Cart from "./Pages/Cart";
import ProductDisplay from "./Components/ProductDisplay/ProductDisplay";
import Sell from "./Pages/Sell";
import Footer from "./Components/Footer/Footer";
import ShopCategory from "./Pages/ShopCategory";
import electronics_banner from "./Components/Assets/electronics.png";
import sports_banner from "./Components/Assets/Sports.png";
import LoginSignup from "./Pages/LoginSignup";
import cycle_banner from "./Components/Assets/Bicycles.png";
import clothes_banner from "./Components/Assets/Clothes.png";
import others_banner from "./Components/Assets/Others.png";
import study_banner from "./Components/Assets/Study_Materials.png";

function App() {
  return (
    <div>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Shop gender="all" />} />
          <Route path="/study" element={<ShopCategory banner={study_banner} category="study" />} />
          <Route path="/electronics" element={<ShopCategory banner={electronics_banner} category="electronics" />} />
          <Route path="/sports" element={<ShopCategory banner={sports_banner} category="sports" />} />
          <Route path="/cycles" element={<ShopCategory banner={cycle_banner} category="cycles" />} />
          <Route path="/clothes" element={<ShopCategory banner={clothes_banner} category="clothes" />} />
          <Route path="/others" element={<ShopCategory banner={others_banner} category="others" />} />
          <Route path="/product/:productId" element={<ProductDisplay />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/login" element={<LoginSignup />} />
          <Route path="/sell" element={<Sell />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
